module.exports = __webpack_public_path__ + "static/media/JohnLee_CV_2023.09c99824.pdf";